// extracted by mini-css-extract-plugin
module.exports = {"version-data-table-item-cta-current":"VersionControlActions_version-data-table-item-cta-current__2sWfR"};